import LinkBox from "../components/LinkBox";

export default function Home(){


    document.getElementsByTagName("body")[0].classList.remove("login-page");
    document.getElementsByTagName("body")[0].classList.add("sidebar-mini");

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">LebenRaffle</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item active">Home</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <div className="content">
                    <div className="container-fluid">
                        <div class="row">
                            <div class="col-6">
                                <LinkBox text='Muestra un listado con todos los sorteos registrados.' value='Ver sorteos' bgColorClass='bg-info' icon='fas fa-list-ul' route={'/raffles'} routeText='Navegar' />
                            </div>
                            <div class="col-6">
                                <LinkBox text='Formulario para registrar un nuevo sorteo.' value='Crear sorteo' bgColorClass='bg-success' icon='fas fa-plus' route={'/add-raffle'} routeText='Navegar' />
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    );

}